// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"vQ","wrapper":"vR","iconButton":"vS","icon":"vT","activeIcon":"vU"};